import React from "react";

import PropTypes from "prop-types";

import Card from "~components/atoms/card/card";
import TransitionComponent from "~components/utils/transition/transition";

import {
  scopedSearchResultInnerStyle,
  scopedSearchResultWrapperStyle,
} from "./search_instant_dropdown_wrapper.module.scss";

const TRANSITION_TIMEOUT = {
  appear: 0,
  enter: 0,
  exit: 300,
};

const SearchInstantDropdownWrapper = ({ show, children }) => {
  return (
    <TransitionComponent
      transition="slideDown"
      unmountOnExit
      isActive={show}
      timeout={TRANSITION_TIMEOUT}
      appear
    >
      <div className={scopedSearchResultWrapperStyle}>
        <Card isFullWidth isRaised>
          <div className={scopedSearchResultInnerStyle}>{children}</div>
        </Card>
      </div>
    </TransitionComponent>
  );
};

export default SearchInstantDropdownWrapper;

SearchInstantDropdownWrapper.defaultProps = {
  show: false,
};
SearchInstantDropdownWrapper.propTypes = {
  show: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
